import React, { useState } from "react";
import RewardsIcon from "../../assets/rewards-icon.png"
import { Link, useNavigate } from 'react-router-dom'
import ArrowLeft from "../../assets/left-icon.png"
import Telegram_icon from "../../assets/telegram_btn.png"
import whatsapp_btn from "../../assets/whatsapp_btn.png"
import { url } from "../../Service/Config";

export default function DepositCrypto() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>

            <div className='crypto-deposit'>
                <div className='inner_title_section'>
                    <div className='container'>
                        <div className='inner_title_flex'>
                            <Link to='/wallet'> <img src={ArrowLeft} /></Link>
                            <h3>Crypto Deposit</h3>
                        </div>
                    </div>
                </div>

                <div className='container'>
                    <div className='crypto_inner'>
                        <div className='crypto_form input_outer'>
                            <div className='form-group-crypto'>
                                <label>Select Crypto</label>
                                <select>
                                    <option>BTC</option>
                                    <option>ETH</option>
                                    <option>SOL</option>
                                </select>
                            </div>
                            <div className='form-group-crypto'>
                                <label>Enter Amount</label>
                                <input type='text' className="amount_input" placeholder="Enter the Amount" />
                            </div>
                            <div className='form-group-crypto'>
                                <label>Enter your transaction hash</label>
                                <input type='text' className="transaction_input" placeholder="Enter your transaction hash" />
                            </div>
                            <div className='deposit_btn'>
                                <button onClick={() => setIsOpen(true)}>Deposit</button>
                            </div>

                        </div>
                        <div className='deposit_note_box'>
                            <h5>Notes</h5>
                            <ul className='notes_list'>
                                <li>1.Users can choose What’sapp and telegram option for own topup and recharges.</li>
                                <li>2.After making the transfer according to the account provided by the customer service of the platform, be sure to submit the receipt of successful transfer or other relevant screenshots to the account for system verification purpose.</li>
                                <li>3.After confirming your request for deposit , it takes time for the transaction to be confirmed on the blockchain. The confirmation time varies depending on the blockchain and its current network traffic.</li>
                                <li>4.The transfer should be done within the time given by the respective customer support.</li>
                                <li>5.Contact customer support based on your preference as to which online transaction modes are required to conduct transactions.</li>
                                <li>6.Please make sure that the selected network matches the network of the platform you are withdrawing funds from. If you select the wrong network, your funds might be lost and cannot be recovered.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className="popup-overlay" onClick={() => setIsOpen(false)}>
                    <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                        <div className="popup-content">
                            <div className='level_modal'>
                                <div className="tele_link_icon">
                                    <button className="whats_button">Whatsapp</button>
                                </div>
                                <div className="what_link_icon">
                                    <button className="whats_button" onClick={() => window.open("/deposit-crypto", "_blank")}>Telegram</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}